import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PorcaSoac } from '../../components/logo-soac/LogoSoac';
import { configureGlobalNotify } from './notify';

type NotifyProviderProps = {
  children: React.ReactNode;
};

configureGlobalNotify();

/**
 * O ícone de todo toast é a porca do SOAC (pedido do Victor, 24/10/2026). A cor da porca e do
 * círculo atrás dela vêm do CSS por tipo (`.toast-soac-icone` em `index.css`), para seguir o tema
 * claro/escuro — as cores passadas aqui são só o fallback do SVG.
 */
const IconeDoToast = () => (
  <span className="toast-soac-icone" aria-hidden="true">
    <PorcaSoac tamanho={18} />
  </span>
);

const NotifyProvider: React.FC<NotifyProviderProps> = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        closeButton
        icon={IconeDoToast}
      />
    </>
  );
};

export default NotifyProvider;
